// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"45bb765b","447":"94d0d920","967":"dba4a9d4"}[chunkId] + ".chunk.js";
};